import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { FormattedMessage, useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { secondaryMarketLiveRepriceQuoteThunk } from 'state/secondaryMarket/live/quote/liveQuote.thunk';

interface RepriceQuoteButtonProps {
  tabId: string;
  color?: 'primary-alt' | 'bid' | 'ask';
}

export function RepriceQuoteButton({ tabId, color = 'primary-alt' }: RepriceQuoteButtonProps) {
  const { formatMessage } = useIntl();
  const dispatch = useThunkDispatch();
  function onReprice() {
    logAnalytics.trackEvent('Secondary market', 'Reprice quote');
    dispatch(secondaryMarketLiveRepriceQuoteThunk(tabId));
  }
  return (
    <button
      type="button"
      className={`btn btn-flat text-${color} btn-icon`}
      title={formatMessage({ id: 'sidePanel.repriceQuote' })}
      onClick={onReprice}
    >
      <i className="icon">refresh</i>
      <span className="visually-hidden">
        <FormattedMessage id="sidePanel.repriceQuote" />
      </span>
    </button>
  );
}
